package com.icebyte.printprofiletracker

// Simple profile model stored in the browser DB
data class StoredProfile(
    val id: String,
    val title: String,
    val description: String,
    val material: String,
    val layerHeight: String,
    val printer: String,
    val notes: String,
    val resultCount: Int = 0,
    val hasPhoto: Boolean = false,
    val hasThreeMf: Boolean = false,
)
